import React from "react";
import styles from "../../../styles/Navbar.module.css";
// import pwcLogo from "assets/newLogo.svg"
import pwcLogo from "assets/images/pwc.svg";
import { Link } from "@mui/material";

const Header = ({ menus }) => {

    return (
        <div className={styles.navbar}>
            <div className={styles.left}>
                <div className={styles.logo} style={{
                    display:'flex',
                    marginTop:'5px'
                }}>
                    <img src={pwcLogo} alt="pwc PMIS Tool" />
                </div>
                <div>
                    <Link href="" underline="none" style={{ fontSize: '16px', color: '#696969' }}>
                        {"Client Setup Manager"}
                    </Link>
                </div>
            </div>
            {/* <div className={styles.right}>
                <Button size="medium" startIcon={<IoIosInformationCircleOutline />} style={{ color: '#C05222', padding: '6px 14px', backgroundColor: '#E8E8E8', textTransform: 'none', fontSize: '16px' }}>
                    Help center
                </Button>
            </div> */}
        </div>
    );
};

export default Header;
